import React, { Component, ReactNode } from 'react';
import { logger } from "@/lib/logger";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

/**
 * ErrorBoundary component to catch runtime errors in the React tree.
 * 2025-06-16 @Cascade
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error('🛑 React Error Boundary caught an error', { error: error, info });
    // TODO: integrate with logging service (e.g., Sentry)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-screen text-red-600 p-4">
          <h1 className="text-2xl font-semibold mb-2">Something went wrong.</h1>
          <p className="mb-4">An unexpected error occurred. Please refresh the page or contact support.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
